export const courseStruct = {
  wrapper: {
    vertical: true,
    gap: "middle",
  },
  table: {
    bordered: true,
    pagination: false,
    scroll: {
      x: 500,
    },
  },

  actionSection: {
    justify: "flex-end",
  },
};
